import { Auth } from '@/shared/lib/auth';
// Прямий імпорт без store-залежностей: читається під час ініціалізації store
import { readStoredSession } from '@/shared/lib/auth/session-storage';

//TODO нужно хорошенько оптимизировать "хранилище"
// Початковий стан береться з одного запису сесії, щоб токен, акаунт і профіль не
// розійшлися, якщо вкладка завантажується під час входу в іншій вкладці.
const storedSession = readStoredSession();

const state = {
  status: '',
  isPartner: storedSession ? storedSession.isPartner : 0,
  isShowBonus: storedSession ? storedSession.isShowBonus : 0,
  token: storedSession ? storedSession.token : '',
  info: storedSession ? storedSession.info : {},
  keyUser: storedSession ? storedSession.keyUser : null,
};
const getters = {
  IS_LOGGED_IN: state => !!state.token,
  AUTH_STATUS: state => state.status,
  IS_PARTNER_STATUS: state => !!+state.isPartner,
  IS_SHOW_BONUS: state => !!+state.isShowBonus,
  USER: state => state.info,
  KEY_USER: state => state.keyUser,
};
const mutations = {
  AUTH_REQUEST(state) {
    state.status = 'loading';
  },
  AUTH_SUCCESS(state, data) {
    state.status = 'success';
    state.isPartner = data?.isPartner;
    state.isShowBonus = data?.isShowBonus;
    state.token = data.token;
    state.info = data.info;
    state.keyUser = 'user_' + data.info?.id;
  },
  SET_USER_INFO(state, info) {
    state.info = info;
  },
  AUTH_ERROR(state) {
    state.status = 'error';
  },
  LOGOUT(state) {
    state.status = '';
    state.token = '';
    state.partners = null;
    state.info = null;
    state.keyUser = null;
  },
};
const actions = {
  LOGIN({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST');
      axios({ url: '/api/auth/login', data: { ...user, is_web: true }, method: 'POST' })
        .then(resp => {
          const token = resp.data.data.token;
          const isPartner = resp.data.data.isPartner ? 1 : 0;
          const isShowBonus = resp.data.data.isShowBonus ? 1 : 0;
          const info = resp.data.data.info;

          // Сесія пишеться одним записом: інша вкладка звіряє власника токена атомарно
          Auth.persistSession({ token, keyUser: 'user_' + info.id, info, isPartner, isShowBonus });

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
          commit('AUTH_SUCCESS', { token: token, isPartner: isPartner, isShowBonus: isShowBonus, info: info });
          resolve(resp);
        })
        .catch(err => {
          commit('AUTH_ERROR');
          Auth.clearSession();

          reject(err);
        });
    });
  },
  LOGIN_WITH_TELEGRAM({ commit }, telegramUser) {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST');
      axios({ url: '/api/auth/telegram/login', data: { ...telegramUser, is_web: true }, method: 'POST' })
        .then(resp => {
          const token = resp.data.data.token;
          const isPartner = resp.data.data.isPartner ? 1 : 0;
          const isShowBonus = resp.data.data.isShowBonus ? 1 : 0;
          const info = resp.data.data.info;

          // Сесія пишеться одним записом: інша вкладка звіряє власника токена атомарно
          Auth.persistSession({ token, keyUser: 'user_' + info.id, info, isPartner, isShowBonus });

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
          commit('AUTH_SUCCESS', { token: token, isPartner: isPartner, isShowBonus: isShowBonus, info: info });
          resolve(resp);
        })
        .catch(err => {
          commit('AUTH_ERROR');
          Auth.clearSession();

          reject(err);
        });
    });
  },
  LOGIN_WITH_TOKEN({ commit }, loginToken) {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST');
      axios({ url: '/api/auth/token-login/' + loginToken, method: 'GET' })
        .then(resp => {
          const token = resp.data.data.token;
          const isPartner = resp.data.data.isPartner ? 1 : 0;
          const isShowBonus = resp.data.data.isShowBonus ? 1 : 0;
          const info = resp.data.data.info;

          // Сесія пишеться одним записом: інша вкладка звіряє власника токена атомарно
          Auth.persistSession({ token, keyUser: 'user_' + info.id, info, isPartner, isShowBonus });

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
          commit('AUTH_SUCCESS', { token: token, isPartner: isPartner, isShowBonus: isShowBonus, info: info });
          resolve(resp);
        })
        .catch(err => {
          commit('AUTH_ERROR');
          Auth.clearSession();

          reject(err);
        });
    });
  },
  REGISTER({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST');
      axios({ url: '/api/auth/register', data: user, method: 'POST' })
        .then(resp => {
          const token = resp.data.data.token;
          const isPartner = resp.data.data.isPartner ? 1 : 0;
          const isShowBonus = 0;
          const info = resp.data.data.info;
          // Сесія пишеться одним записом: інша вкладка звіряє власника токена атомарно
          Auth.persistSession({ token, keyUser: 'user_' + info.id, info, isPartner, isShowBonus });

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
          commit('AUTH_SUCCESS', { token: token, isPartner: isPartner, info: info });
          resolve(resp);
        })
        .catch(err => {
          commit('AUTH_ERROR', err);
          Auth.clearSession();

          reject(err);
        });
    });
  },
  LOGOUT({ commit }) {
    return new Promise((resolve, reject) => {
      commit('LOGOUT');
      Auth.clearSession();
      delete axios.defaults.headers.common['Authorization'];
      resolve();
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
